import React, { useState, useRef } from "react";
import { poolId } from './variables/poolid';

const Ticker: React.FC = () => {
  const [isPaused, setIsPaused] = useState(false);
  const tickerRef = useRef<HTMLDivElement | null>(null);

  const handleMouseEnter = () => setIsPaused(true);
  const handleMouseLeave = () => setIsPaused(false);

  return (
    <div className="overflow-hidden whitespace-nowrap" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      <div
        ref={tickerRef}
        className="inline-block px-6 text-white font-semibold animate-scroll text-lg"
        style={{ animationPlayState: isPaused ? 'paused' : 'running' }}
      >
        SN₳KE is a pioneer Cardano stake pool delivering secure infrastructure, transparent operations and long-term commitment since the Shelley era. DRep: drep1yt56tpzpzu58zy7pz4zwfp32rq95tj3xfxmdrg8k3qhxjlccp47cn &nbsp;
        <strong>Pool ID: </strong> 
        <a
          href={`https://adastat.net/pools/${poolId}`}
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-400 hover:underline link-primary"
        >
          {poolId}
        </a> &nbsp;
        <strong>Ticker: </strong> 
        <a
          href={`https://adastat.net/pools/${poolId}`}
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-400 hover:underline link-primary"
        >
          SNAKE
        </a>
      </div>
    </div>
  );
};

export { Ticker };
